import { Coin } from "./Coin";

export interface AllExchangesResponse{
    [name: string]: ExchangePairs;
}

export interface ExchangePairs{
    [base: string]: string[];
}

//Single exchange
export class Exchange{
  // coins: string[] = [];
  pairs: ExchangePairs;
  name: string;
  constructor(pairs: ExchangePairs, name: string){
      this.pairs = pairs;
      this.name = name;
  }

  public hasCoin(coin: Coin): boolean{
    let name = coin.Name;

    //First pass - over the base currency
    for(let base in this.pairs){
        if(base == name) return true;
    }

    for(let base in this.pairs){
        for(let quote of this.pairs[base]){
            if(quote == name) return true;
        }
    }
    return false;
  }

  public getPairs(): string[]{
    let list = [];
    for(let base in this.pairs){
      for(let quote of this.pairs[base]){
        list.push(`${base}/${quote}`);
      }
    }
    return list;
  }

  public getPairsForQuote(quote: string): string[]{
    let list = [];
    for(let base in this.pairs){
      for(let q of this.pairs[base]){
        if(quote == q){
          list.push(`${base}/${quote}`);
        }
      }
    }
    return list;
  }

  public getPairsForCoin(coin: Coin): string[]{
    let list = [];
    for(let base in this.pairs){
      for(let quote of this.pairs[base]){
        let pair = `${base}/${quote}`;
        if(base == coin.Name && list.indexOf(pair) < 0){
          list.push(pair);
        }else if(quote == coin.Name && list.indexOf(pair) < 0){
          list.push(pair);
        }
      }
    }
    return list;
  }

  public getQuoteCurrencies(): string[]{
    let list = [];
    for(let base in this.pairs){
      for(let quote of this.pairs[base]){
        if(list.indexOf(quote) < 0){
          list.push(quote);
        }
      }
    }
    return list;
  }
  //From = base, to = quote
  public getAssociatedPairs(coin: Coin){
    let map = {
      from: [],
      to: []
    };
    for(let base in this.pairs){
      for(let quote of this.pairs[base]){
        if(base == coin.Name){
          map.to.push(quote);
        }else if(quote == coin.Name){
          map.from.push(base);
        }
      }
    }
    return map;
  }
}

//All exchanges as an object
export class Exchanges{
  exchanges: Exchange[] = [];

  constructor(exchanges: AllExchangesResponse){
    for(let e in exchanges){
        this.exchanges.push(new Exchange(exchanges[e], e));
    }
  }

  public getExchangesForCoin(coin: Coin): Exchange[]{
    let exchanges: Exchange[] = [];
    for(let e of this.exchanges){
        if(e.hasCoin(coin)) exchanges.push(e);
    }
    return exchanges;
  }

  /**
   * Gets all pairs across all exchange for given coin
   * @param coin coin you want pairs for
   */
  public getPairsForCoin(coin: Coin): string[]{
    let list = [];

    for(let exchange of this.exchanges)
      for(let base in exchange.pairs){
        for(let quote of exchange.pairs[base]){
          let pair = `${base}/${quote}`;
          if(base == coin.Name && list.indexOf(pair) < 0){
            list.push(pair);
          }else if(quote == coin.Name && list.indexOf(pair) < 0){
            list.push(pair);
          }
        }
      }
    return list;
  }

  /**
   * Gets all base currencies that trade against this coin (base/<coin>)
   * @param coin
   */
  public getBasesForCoin(coin: Coin): string[]{
    let list = [];

    for(let exchange of this.exchanges)
      for(let base in exchange.pairs){
        for(let quote of exchange.pairs[base]){
          if(quote == coin.Name && list.indexOf(base) < 0){
            list.push(base);
          }
        }
      }
    return list;
  }

  public getAssociatedCurrencies(coin: Coin): string[]{
    let list = [];

    for(let exchange of this.exchanges)
      for(let base in exchange.pairs){
        if(base == coin.Name){
          for(let quote of exchange.pairs[base]){
            if(list.indexOf(quote) < 0){
              list.push(quote);
            }
          }
        }else{
          for(let quote of exchange.pairs[base]){
            if(quote == coin.Name && list.indexOf(base) < 0){
              list.push(base);
            }
          }
        }
      }
    return list;
  }
}

export class TopExchange{
  pairs: TopPair[] = [];
  name: string;
  constructor(snapshots: ExchangeSnapshot[]){
    for(let snapshot of snapshots){
      this.pairs.push(new TopPair(snapshot));
    }

    this.name = snapshots[0].MARKET;
  }
}

// export class TopExchanges{
//   exchanges: TopExchange[];
//   constructor(responses: TopExchangeResponse[]){
//     for(let res of responses)
//   }
// }

export class TopPair{
  base: string;
  quote: string;
  price: number;
  volume: number;

  constructor(snapshot: ExchangeSnapshot){
    this.base = snapshot.FROMSYMBOL;
    this.quote = snapshot.TOSYMBOL;
    this.price = snapshot.PRICE;
    this.volume = snapshot.VOLUME24HOURTO;
  }
}

export interface TopExchangeResponse {
  Response: string;
  Message: string;
  Data: Data;
}

interface Data {
  CoinInfo: CoinInfo;
  AggregatedData: AggregatedData;
  Exchanges: ExchangeSnapshot[];
}

interface ExchangeSnapshot {
  TYPE: string;
  MARKET: string;
  FROMSYMBOL: string;
  TOSYMBOL: string;
  FLAGS: string;
  PRICE: number;
  LASTUPDATE: number;
  LASTVOLUME: number;
  LASTVOLUMETO: number;
  LASTTRADEID: string;
  VOLUME24HOUR: number;
  VOLUME24HOURTO: number;
  OPEN24HOUR: number;
  HIGH24HOUR: number;
  LOW24HOUR: number;
  CHANGE24HOUR: number;
  CHANGEPCT24HOUR: number;
  CHANGEDAY: number;
  CHANGEPCTDAY: number;
}

interface AggregatedData {
  TYPE: string;
  MARKET: string;
  FROMSYMBOL: string;
  TOSYMBOL: string;
  FLAGS: string;
  PRICE: number;
  LASTUPDATE: number;
  LASTVOLUME: number;
  LASTVOLUMETO: number;
  LASTTRADEID: string;
  VOLUMEDAY: number;
  VOLUMEDAYTO: number;
  VOLUME24HOUR: number;
  VOLUME24HOURTO: number;
  OPENDAY: number;
  HIGHDAY: number;
  LOWDAY: number;
  OPEN24HOUR: number;
  HIGH24HOUR: number;
  LOW24HOUR: number;
  LASTMARKET: string;
  CHANGE24HOUR: number;
  CHANGEPCT24HOUR: number;
  CHANGEDAY: number;
  CHANGEPCTDAY: number;
}

interface CoinInfo {
}



// WEBPACK FOOTER //
// ./src/models/Exchanges.ts